import { render, staticRenderFns } from "./cModalConvenio.vue?vue&type=template&id=0143d9b6"
import script from "./cModalConvenio.vue?vue&type=script&lang=js"
export * from "./cModalConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports